export default function Toggle({label, checked, name, tooltip, tooltipTitle, tooltipIcon, onChange}) {
    return (
        <div className={"bg-base-100 rounded-field border border-neutral min-h-[calc(var(--size-field)*10)] py-[9px] px-[calc(var(--size-field)*3)]"}>
            <fieldset className="daisy-fieldset p-0 flex items-center h-full">
                <label className="daisy-label flex justify-between items-center flex-1 whitespace-normal flex-wrap">
                    {label && (
                        <span className={"flex items-center text-label mr-[9px]"}>
                            {label}
                            {tooltip && (
                                <div className={"ml-[4px] daisy-tooltip daisy-tooltip-bottom daisy-tooltip-accent"}>
                                    {tooltipIcon || '?'}
                                    <div className="daisy-tooltip-content text-left text-small p-[24px] leading-[24px] !left-[64px] lg:!left-auto">
                                        {tooltipTitle && <><strong>{tooltipTitle}</strong><br/></>}
                                        {tooltip}
                                    </div>
                                </div>
                            )}
                        </span>
                    )}
                    <input
                        type="checkbox"
                        name={name}
                        checked={checked}
                        onChange={(e) => onChange && onChange(e.target.checked)}
                        className="daisy-toggle bg-fill-secondary border-none text-white checked:bg-fill-secondary checked:text-brand-blue checked:border-none"
                    />
                </label>
            </fieldset>
        </div>
    )
}
